import React from "react";
import moment from 'moment';
import withNotify from "../../../lib/NotificationWrapper";

// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    Form, FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";

import apiRequest from "../../../lib/Api";
import Select from "react-select";


class ExportacaoAtendimentosEspecialistas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datainicial: moment().startOf('month').format('YYYY-MM-DD'),
            datafinal: moment().endOf('month').format('YYYY-MM-DD'),

            specialists: [],
            users: [],
            selectedSpecialist: null,
            selectedUser: null,
        };
    }

    loadSpecialists = () => {
        const data = {searchRole: 'specialist'};
        apiRequest("/users", {method: "GET", data})
          .then(response => {
              const list = response.data && response.data.data ? response.data.data : [];
              const specialists = list.map(u => ({value: u.id, label: u.name}));
              this.setState({specialists});
          })
          .catch(() => {
              this.setState({specialists: []});
          });
    }

    loadUsers = () => {

        if (!this.state.selectedSpecialist) {
            return
        }
        apiRequest(`/specialist/${this.state.selectedSpecialist.value}/patients`, {method: "GET"})
          .then(response => {
              const list = response.data && response.data.data ? response.data.data : [];
              if (list.length === 0) {
                  this.props.notify({type: 'warning', message: window.gettext('Nenhum usuário encontrado para o especialista selecionado.')});
              }
              const users = list.map(u => ({value: u.id, label: u.name}));
              this.setState({users});
          })
          .catch(() => {
              this.setState({users: []});
          });
    }


    componentDidMount() {
        this.loadSpecialists();
    }

    setValues = event => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({[name]: value});
    }

    export = (newReport) => {

        let datainicial = moment(this.state.datainicial);
        let datafinal   = moment(this.state.datafinal);

        if ( datainicial > datafinal ) {
            this.props.notify({type: 'warning', message: window.gettext('A data inicial selecionada é maior que a data final. Corriga para continuar com a exportação.')});
            return false;
        }

        let data = {
            datainicial: this.state.datainicial,
            datafinal: this.state.datafinal,
            specialist_id: this.state.selectedSpecialist ? this.state.selectedSpecialist.value : undefined,
            user_id: this.state.selectedUser ? this.state.selectedUser.value : undefined,
            newReport: newReport || false,
        };

        const now = moment();
        const date = now.format('DD/MM/YYYY');
        const hour = now.format('HH:mm');

        apiRequest("/reports/appointments/export", {method: "GET", data}, {blob: true})
            .then(blob => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                const nameFile = `atendimentos_${date}_${hour}.xlsx`;
                link.setAttribute('download', nameFile);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
    }

    specialistChoosed = (opt) => {
        this.setState({selectedSpecialist: opt, selectedUser: null}, this.loadUsers);
    }


    render() {

        return (
            <>
                <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h4">
                                      {window.gettext('Exportação de atendimento')}
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <Form className="form-horizontal mb-2">
                                        <Row>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Label>{window.gettext('Data inicial')}</Label>
                                                    <Input
                                                      type="date"
                                                      name="datainicial"
                                                      value={this.state.datainicial}
                                                      onChange={this.setValues}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Label>{window.gettext('Data final')}</Label>
                                                    <Input
                                                      type="date"
                                                      name="datafinal"
                                                      value={this.state.datafinal}
                                                      onChange={this.setValues}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="3" className="d-flex align-items-center">
                                                <Button
                                                  color="primary"
                                                  type="button"
                                                  style={{margin: 0}}
                                                  onClick={() => this.export(false)}
                                                >
                                                    {window.gettext('Exportar')}
                                                </Button>
                                            </Col>
                                        </Row>

                                        <Row style={{marginTop: 15}}>
                                            <Col md="3">
                                                <Label>{window.gettext('Especialista')}</Label>
                                                <Select
                                                  className="react-select primary"
                                                  classNamePrefix="react-select"
                                                  placeholder={window.gettext('Selecione o especialista')}
                                                  options={this.state.specialists}
                                                  value={this.state.selectedSpecialist}
                                                  onChange={(opt) => this.specialistChoosed(opt)}
                                                  isClearable
                                                />
                                            </Col>
                                            <Col md="3">
                                                <Label>{window.gettext('Usuário')}</Label>
                                                <Select
                                                  className="react-select primary"
                                                  classNamePrefix="react-select"
                                                  placeholder={window.gettext('Selecione o usuário')}
                                                  options={this.state.users}
                                                  value={this.state.selectedUser}
                                                  onChange={(opt) => this.setState({selectedUser: opt})}
                                                  isClearable
                                                />
                                            </Col>
                                        </Row>

                                    </Form>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </div>
            </>
        );
    }
}

export default withNotify(ExportacaoAtendimentosEspecialistas) ;
